/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { FC_PACKING_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { FcPage } from "@/features/processing/components/fc-page";

export const Route = createFileRoute("/_app/packaging/fc-packing-slip/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(FC_PACKING_FORM))
      throw redirect({ to: "/packaging/fc-packing-slip" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <FcPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
